import { render, staticRenderFns } from "./onePay.vue?vue&type=template&id=3e310ef5"
import script from "./onePay.vue?vue&type=script&lang=ts"
export * from "./onePay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports